import React from 'react';

type Props = {
  width?: string,
  height?: string,
  stroke?: string,
  className: string,
}

const VideoLibrary = ({ className, stroke, width, height }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 12.7 12.7"
    width={width}
    height={height}
    className={className}
    transform="scale(1.3)"
  >
    <g>
      <g
        fill="none"
        stroke={stroke}
        strokeDasharray="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeOpacity="1"
        strokeWidth="0.529"
      >
        <path
          d="M10.57 6.35a4.22 4.22 0 11-8.44 0 4.22 4.22 0 018.44 0z"
          opacity="0.999"
          stopOpacity="1"
        />
        <path
          d="M5.29 6.724V4.951c0-.488.346-.688.768-.444l1.536.887c.422.244.422.643 0 .887l-1.536.886c-.422.244-.768.045-.768-.443z"
          opacity="0.999"
          stopOpacity="1"
        />
        <path d="M3.1 9.042h6.386" opacity="0.999" stopOpacity="1" />
      </g>
    </g>
  </svg>
);


VideoLibrary.defaultProps = {
  stroke: '#1a1818',
  width: '48',
  height: '48',
};

export default VideoLibrary;
